<template>
  <div class="contain">
    <div style="position: relative;">
      <el-carousel height="650px" class="home-box">
        <el-carousel-item v-for="itemImg in homeUrl" :key="itemImg.id" arrow="always">
          <img :src="itemImg.homeImage" style="width: 100%;height: 100%" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="cascader-ps">
      <div class="home-radius home-ship-query" style="width: 700px;">
        <div class="home-tx-center" style="font-size: 60px; font-family: Arial">WE PROVIDE</div>
        <el-row style="width: 1000px;">
          <el-col :span="12">
            <div
              class="home-tx-center"
              style="font-size: 30px; font-weight: normal; letter-spacing: 1px; margin-top: 15px"
            >数字化物流运营平台</div>
          </el-col>
          <!-- <div class="home-bg-zu"> -->
          <el-col :span="2" class="home-font home-bg-zu" style="text-align: center;">起运港</el-col>
          <el-col :span="4" class="home-bg-zu">
            <el-select
              class="home-port"
              popper-class="homeSelect"
              v-model="startPortCode"
              filterable
              clearable
              remote
              :popper-append-to-body="false"
              default-first-option
              placeholder="请输入起运港"
              :remote-method="remoteStart"
              @focus="getNewFocus('start')"
              @change="getHandeleStart"
            >
              <el-option
                v-for="(item,index) in startPortList"
                :key="index"
                :label="item.portEn"
                :value="item.portCode"
              >
                <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2" class="home-font home-bg-zu" style="text-align: center;">目的港</el-col>
          <el-col :span="4" class="home-bg-zu">
            <el-select
              class="home-port"
              v-model="reachPortCode"
              popper-class="homeSelect"
              :popper-append-to-body="false"
              filterable
              clearable
              remote
              default-first-option
              placeholder="请输入目的港"
              :remote-method="remoteReach"
              @focus="getNewFocus('reach')"
              @change="getHandeleReach"
            >
              <el-option
                v-for="(item,index) in reachPortList"
                :key="index"
                :label="item.portEn"
                :value="item.portCode"
              >
                <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" class="home-bg-zu" style="width: 0px">
            <el-button
              class="home-el-button"
              icon="el-icon-search"
              style="width: 140px;"
              @click="queryShipDate"
            >船期查询</el-button>
          </el-col>
          <!-- </div> -->
        </el-row>
        <div
          class="home-tx-center"
          style="font-size: 30px; font-weight: normal; letter-spacing: 1px"
        >智能化供应链管理</div>
        <div
          class="home-tx-center"
          style="font-size: 30px; font-weight: normal; letter-spacing: 1px"
        >高效一流的货物运输服务</div>
      </div>
    </div>

    <div class="home-track-bg">
      <div style="position: relative;padding-top: 60px;">
        <div class="home-service-pd home-div-box1">
          <div style="display: inline-block;margin-top: 200px;margin-right: 20px;">
            <img src="../assets/img/home-pic1.png" style="width: 800px;" />
          </div>
          <div style="display: inline-block;position: relative;top: -130px;width: 320px;">
            <div class="home-ww-font20">船期100%准确真实</div>
            <div class="home-ww-font">实时在线查询</div>
            <div
              class="home-ww-font2"
              style="padding-top:30px;"
            >中航运对接了航运业界主流的30+船公司，船期数据实时精准。通过系统对接，为您提供航线、船名、港到港等多种查询方式，您可以自由选择想要的方式进行船期查询</div>
          </div>
        </div>
      </div>
      <div style="position: relative;padding-top: 60px;">
        <div class="home-service-pd home-div-box2">
          <div style="display: inline-block;position: relative;top: -60px;width: 320px;">
            <div class="home-ww-font20" style="text-align: left;">快递查询一般的</div>
            <div class="home-ww-font" style="text-align: left;">物流跟踪服务</div>
            <div
              class="home-ww-font2"
              style="padding-top:30px;"
            >中航运已打通港口、船舶、仓库、拖车、海关等数据节点，物流动态清晰准。通过强大的系统支持提供运输风险提前预警，同时我们的物流专家将会为您提供及时的应对策略</div>
          </div>
          <div style="display: inline-block;margin-top: 150px;margin-left: 20px;">
            <img src="../assets/img/track-query.png" style="width: 800px;" />
          </div>
        </div>
      </div>
      <div style="position: relative;padding-top: 60px;">
        <div class="home-service-pd home-div-box3">
          <div style="display: inline-block;margin-top: 150px;margin-right: 20px;">
            <img src="../assets/img/home-pic3.png" style="width: 670px;" />
          </div>
          <div style="display: inline-block;position: relative;top: -100px;width: 500px;">
            <div class="home-ww-font20" style="text-align: left;">简单快捷的</div>
            <div class="home-ww-font" style="text-align: left;">订单管理+业务协作</div>
            <div
              class="home-ww-font2"
              style="padding-top:30px;text-align: left;"
            >中航运利用领先的系统服务能力和线下实体资源网络来支撑您的业务。通过多系统协作以及线下资源网络，您的订单在系统中被自动分发给到服务方，同时通过实时监控、预警推送等功能为您提供反馈</div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative;background-color: #fff;">
      <div class="home-service-pd home-div-box4" style="position: relative;z-index: 888;">
        <div class="home-pd1">
          <div class="home-font20 home-pd2" style="padding-top:150px ">我们的合作伙伴</div>
          <div class>
            <el-row>
              <el-col
                class="col-img"
                style="width: 16%;"
                v-for="(item,index) in partnerList"
                :key="item.id"
              >
                <img :src="item.partnerUrl" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ElCol from "element-ui/packages/col/src/col";
// import ElRow from "element-ui/packages/row/src/row";
export default {
  // components: { ElRow, ElCol },
  data() {
    return {
      startPort: "", //起始港
      reachPort: "", //目的港
      startPortCode: "", //起运港五字码
      reachPortCode: "", //目的港五字码
      startItem: {},
      reachItem: {},
      selectFocus: "", //选中的是起运港或目的港标识
      startPortList: [], //起运港数据
      reachPortList: [], //目的港数据
      originPortCode: "", //起运港code
      destinationPortCode: "", //目的港code
      gutter: 10,
      partnerList: [
        //合作伙伴图片
        { id: 0, partnerUrl: require("../assets/img/CMA.png") },
        { id: 1, partnerUrl: require("../assets/img/COSCO.png") },
        { id: 2, partnerUrl: require("../assets/img/EVERGREEN.png") },
        { id: 3, partnerUrl: require("../assets/img/FESCO.png") },
        { id: 4, partnerUrl: require("../assets/img/HAMBURG SUD.png") },
        { id: 5, partnerUrl: require("../assets/img/HAPAG.png") },
        { id: 6, partnerUrl: require("../assets/img/PIL.png") },
        { id: 7, partnerUrl: require("../assets/img/MCC.png") },
        { id: 8, partnerUrl: require("../assets/img/ONE.png") },
        { id: 9, partnerUrl: require("../assets/img/OOCL.png") },
        { id: 10, partnerUrl: require("../assets/img/RCL.png") },
        { id: 11, partnerUrl: require("../assets/img/MSC.png") },
        { id: 12, partnerUrl: require("../assets/img/SAF.png") },
        { id: 13, partnerUrl: require("../assets/img/SITC.png") },
        { id: 14, partnerUrl: require("../assets/img/WANHAI.png") },
        { id: 15, partnerUrl: require("../assets/img/YML.png") },
        { id: 16, partnerUrl: require("../assets/img/ZIM.png") },
        { id: 17, partnerUrl: require("../assets/img/MSK.png") }
      ],
      homeUrl: [
        //轮播图片
        { id: 0, homeImage: require("../assets/img/container.png") }
      ]
    };
  },

  methods: {
    handleSelect: function(key, keyPath) {
      //tab变化
      console.log(key, keyPath);
    },
    //起运港选中值发生变化时触发
    getHandeleStart(value) {
      var objItem = this.startPortList.find(item => {
        this.startItem = item;
        return item.transportPointFiveChar === value;
      });
      if (typeof objItem == "object") {
        this.startPort = objItem.portFullNameEn;
        this.originPortCode = objItem.transportPointCode;
      } else {
        this.startPort = "";
      }
    },
    //目的港选中值发生变化时触发
    getHandeleReach(value) {
      var objItem = this.reachPortList.find(item => {
        this.reachItem = item;
        return item.transportPointFiveChar === value;
      });
      if (typeof objItem == "object") {
        this.reachPort = objItem.portFullNameEn;
        this.destinationPortCode = objItem.transportPointCode;
      } else {
        this.reachPort = "";
      }
    },
    //查询船期按钮
    queryShipDate() {
      this.$router.push({
        name: "ShipSchedule",
        params: {
          startPortCode: this.startPortCode,
          startPort: this.startPort,
          reachPortCode: this.reachPortCode,
          reachPort: this.reachPort,
          startItem: this.startItem,
          reachItem: this.reachItem,
          originPortCode: this.originPortCode,
          destinationPortCode: this.destinationPortCode
        }
      });
    },
    //监听起运港输入框的值
    remoteStart(value) {
      this.getPortData(value, "start");
    },
    //监听目的港输入框的值
    remoteReach(value) {
      this.getPortData(value, "reach");
    },
    //起运港和目的港获取焦点事件
    getNewFocus(type) {
      switch (type) {
        case "start":
          this.getPortData(this.startPort, type);
          break;
        case "reach":
          this.getPortData(this.reachPort, type);
          break;
      }
    },
    //获取起运港和目的港港口数据
    getPortData(val, type) {
      let that = this;
      let params = {};
      params.strKey = val;
      let response = this.apiService
        .get("/sinoslog-common-service/mdPort/getMdPortInfo", { params })
        .then(res => {
          switch (type) {
            case "start":
              that.startPortList = res.data.data.records;
              break;
            case "reach":
              that.reachPortList = res.data.data.records;
              break;
          }
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.home-ship-query {
  line-height: 60px;
  text-align: left;
  margin-top: 10px;
  position: absolute;
  top: 230px;
  z-index: 3;
}
.home-bg-zu {
  background-color: #fff;
  opacity: 0.9;
  height: 50px !important;
  line-height: 50px !important;
}
.home-bg-zu
  > .home-port
  > .el-input
  > .el-input__suffix
  > .el-input__suffix-inner
  > .el-input__icon {
  line-height: 50px !important;
}
.home-tx-center {
  font-family: "SourceHanSans-Regular";
  font-size: 50px;
  line-height: normal;
  color: #fff;
  font-weight: bold;
  letter-spacing: 3px;
}
.home-track-bg {
  background-color: #fff;
  /* padding-bottom: 50px; */
}
.home-track-margin {
  width: 1200px;
  margin: 0 auto;
}
.home-track-margin img {
  width: 100%;
}
</style>








// WEBPACK FOOTER //
// src/views/Home.vue